import { render, staticRenderFns } from "./DataListHealthFacilities.vue?vue&type=template&id=fb214dec&scoped=true&"
import script from "./DataListHealthFacilities.vue?vue&type=script&lang=js&"
export * from "./DataListHealthFacilities.vue?vue&type=script&lang=js&"
import style0 from "./DataListHealthFacilities.vue?vue&type=style&index=0&id=fb214dec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb214dec",
  null
  
)

export default component.exports